import { InjectionToken } from '@angular/core';

export const APP_SHORT_NAME = new InjectionToken<string>(
  'Application short name'
);
export const APP_MAIN_ICON = new InjectionToken<string>(
  'Application main icon'
);

export const APP_MAIN_ICON_FONT_SET = new InjectionToken<string>(
  'Application main icon font set',
  { providedIn: 'root', factory: () => '' }
);
export const APP_MAIN_PAGE = new InjectionToken<string>(
  'Application main page'
);
export const RECAPTCHA_SITE_KEY = new InjectionToken<string>(
  'ReCaptcha Site Key'
);
